import React from 'react';
import { Step, stepClasses, StepLabel, Stepper, styled } from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

import StepIcon from './StepIcon';
import StepLabelComponent from './StepLabel';

function CommonStepper({ activeStep, steps }) {
  return (
    <Stepper activeStep={activeStep} connector={<StyledConnector />} sx={{ width: '100%', padding: 0, margin: 0 }}>
      {steps.map((label) => (
        <StyledStep key={label}>
          <StepLabel slots={{ stepIcon: StepIcon, label: StepLabelComponent }}>{label}</StepLabel>
        </StyledStep>
      ))}
    </Stepper>
  );
}

export default CommonStepper;

const StyledStep = styled(Step)(() => ({
  [`&.${stepClasses.root}`]: {
    padding: '0',
  },
}));

const StyledConnector = styled(StepConnector)(() => ({
  // [`&.${stepConnectorClasses.alternativeLabel}`]: {
  //   top: 10,
  // },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: 'var(--color-primary)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: 'var(--color-primary)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: 'var(--divider-color)',
    borderTopWidth: 3,
    borderRadius: 1,
    marginInline: '4px',
  },
}));
